import iconfontJs from '../assets/iconfont/iconfont.js?url'
import iconfontJson from '../assets/iconfont/iconfont.json?url'
const iconfontId = '3887752_s4mj4gqm2kl'
export const iconConfig = {
  url: isDev() ? `https://at.alicdn.com/t/c/font_${iconfontId}.js` : iconfontJs,
  jsonUrl: isDev()
    ? `https://at.alicdn.com/t/c/font_${iconfontId}.json?spm=a313x.7781069.1998910419.53&file=font_${iconfontId}.json`
    : iconfontJson
}
